import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "fileItem" ]

  connect () {
    let hiddenInput = this.fileItemTarget.querySelector('.cache-file-name')
    this.showFileAttachmentName(hiddenInput)
  }

  change (event) {
    let fileInput = this.fileItemTarget.querySelector('input')
    this.showFileAttachmentName(fileInput)
  }

  showFileAttachmentName (fileInput) {
    if (fileInput == null) {
      return
    }
    let html = `<span class="file-attachment-name">${fileInput.value.split(/(\\|\/)/g).pop()}</span>`
    let oldFile = this.fileItemTarget.querySelector('.file-attachment-name')
    oldFile && oldFile.destroy()
    this.fileItemTarget.appendHTML(html)
  }
}